import { AfterViewInit, Component, HostListener, OnInit } from "@angular/core";
import { ProfileService, SessionService, SocketService } from "./services";
import { ClevertapEventsService, NotificationsService } from "./services";
import { FacebookService } from "ngx-facebook";
import { Toast, ToasterService } from "angular2-toaster";
import { VersionChecker } from "./helpers";
import { Router } from "@angular/router";
import { FeatureFlagService } from "./services/feature-flag.service";

@Component({
  // tslint:disable-next-line
  selector: "body",
  template:
    "<app-on-boarding></app-on-boarding><toaster-container></toaster-container><router-outlet></router-outlet>",
  providers: [
    ProfileService,
    NotificationsService,
    SessionService,
    ToasterService,
  ],
})
export class AppComponent implements AfterViewInit, OnInit {
  private user;

  constructor(
    profile: ProfileService,
    notificationsService: NotificationsService,
    fb: FacebookService,
    private sessionService: SessionService,
    // private socketService: SocketService,
    private toasterService: ToasterService,
    private versionChecker: VersionChecker,
    private router: Router,
    private readonly featureFlagService: FeatureFlagService
  ) {
    const token = localStorage.getItem("token");
    let userData = localStorage.getItem("userData");
    if (token && userData) {
      // socketService.initSocket();
      profile.getUser().subscribe(
        (user) => {
          userData = JSON.parse(userData);
          userData["OperatorCapability"] = user["OperatorCapability"];
          localStorage.setItem("userData", JSON.stringify(userData));
          ClevertapEventsService.emitLogin(user);
          this.featureFlagService.emitUser(user);
          ClevertapEventsService.emitEvent("didAccess");
        },
        (_err) => {
          console.log(_err);
          this.router.navigate(["/login"]);
        }
      );

      const _error = sessionService.get("_error");
      if (_error) {
        setTimeout(() => {
          toasterService.pop(
            "error",
            "An error occurred",
            "We are investigating to fix it as soon as possible"
          );
        });
        console.log("An error occurred ->", _error);
      }

      // this.notifications_sub = notificationsService.getNotifications()
      //   .subscribe(notifications => {
      //     notifications.subscribe(n => {
      //       n.forEach(_n => {
      //         console.log('Received notification =>', _n);
      //         if (!_n.viewed) {
      //           notificationsService.setViewed(_n.id)
      //             .subscribe(res => {
      //               // console.log('setViewed', res);
      //             });
      //           notificationsService.spawn(_n.title, _n.body, _n.img, _n.link);
      //         }
      //       });
      //     });
      //   });
    } else {
      if (!window.location.href.indexOf("token")) {
        this.router.navigate(["/login"], { queryParamsHandling: "preserve" });
      }
    }
  }

  ngOnInit() {
    this.featureFlagService.start();
  }

  ngAfterViewInit() {
    this.sessionService.clear();
    this.versionChecker.initVersionCheck();
    this.browserCheck();
  }

  public browserCheck() {
    // Check browser compatibility
    const isIE11 =
      !!window["MSInputMethodContext"] && !!document["documentMode"];
    if (isIE11) {
      const toast: Toast = {
        type: "warning",
        title: "This browser is currently not supported",
        body: "We recommend using the latest Microsoft Edge, Google Chrome or Firefox.",
        showCloseButton: false,
        timeout: 0,
      };
      this.toasterService.pop(toast);
    }
  }

  @HostListener("window:message", ["$event"])
  onMessage(event) {
    if (
      event &&
      event.data &&
      event.data.type &&
      event.data.type === "refresh"
    ) {
      try {
        caches
          .keys()
          .then((keyList) =>
            Promise.all(keyList.map((key) => caches.delete(key)))
          )
          .then(() => window.location.reload());
      } catch (e) {
        window.location.reload();
      }
    }
  }
}
